export enum Discipline {
    ONLINE_MARKETING = "Online Marketing",
    DESIGN = "Design",
    TEXT = "Text",
    BERATUNG = "Beratung"
}